import { AvatarConfig } from "../avatar/common/player/type";
import { ResourceType } from "../base/loader/type";
import { SmartScenarioBuilders } from "../avatar/common/player/util";
import { defaultConfig } from "./default.config";
import type { CameraConfig } from '../base/camera/type';
import type { LightingConfig } from '../base/light/type';
import type { RendererConfig } from '../base/renderer/type';
import type { LoaderConfig } from '../base/loader/type';
import type { ScenarioConfigs } from '../avatar/common/animation/type';

// Nalnani 리소스 설정
export const nalnaniResources: ResourceType[] = [
  { name: "nalnani", type: "model_only", path: "/glb/avatars/nn_avatar_nani_00001.glb", format: "glb" },
  // { name: "afterpayment_bye01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@afterpayment_bye01_a.glb", format: "glb" },
  // { name: "afterpayment_bye01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@afterpayment_bye01_b.glb", format: "glb" },
  // 사용되지 않는 애니메이션 (bye 시나리오에서 01_a, 01_b만 사용)
  // { name: "afterpayment_bye02_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@afterpayment_bye02_a.glb", format: "glb" },
  // { name: "afterpayment_bye02_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@afterpayment_bye02_b.glb", format: "glb" },
  // { name: "afterpayment_pickup01", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@afterpayment_pickup01.glb", format: "glb" },
  { name: "greeting_hi01", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@greeting_hi01.glb", format: "glb" },
  // 사용되지 않는 애니메이션 (hi 시나리오에서 hi01과 start01만 사용)
  { name: "greeting_hi02", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@greeting_hi02.glb", format: "glb" },
  { name: "greeting_start01", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@greeting_start01.glb", format: "glb" },
  { name: "input_listening01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_listening01_a.glb", format: "glb" },
  { name: "input_listening01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_listening01_b.glb", format: "glb" },
  { name: "input_listening02_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_listening02_a.glb", format: "glb" },
  { name: "input_listening02_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_listening02_b.glb", format: "glb" },
  { name: "input_processing01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_processing01_a.glb", format: "glb" },
  { name: "input_processing01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_processing01_b.glb", format: "glb" },
  { name: "input_waiting01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_waiting01_a.glb", format: "glb" },
  { name: "input_waiting01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_waiting01_b.glb", format: "glb" },
  { name: "input_waiting02_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_waiting02_a.glb", format: "glb" },
  { name: "input_waiting02_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@input_waiting02_b.glb", format: "glb" },
  // { name: "payment_moveright01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@payment_moveright01_a.glb", format: "glb" },
  // { name: "payment_moveright01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@payment_moveright01_b.glb", format: "glb" },
  { name: "payment_toss01", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@payment_toss01.glb", format: "glb" },
  { name: "response_error01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_error01_a.glb", format: "glb" },
  { name: "response_error01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_error01_b.glb", format: "glb" },
  { name: "response_error01_c", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_error01_c.glb", format: "glb" },
  // { name: "response_introduce01", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_introduce01.glb", format: "glb" },
  // { name: "response_outofstock_exchange01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_outofstock_exchange01_a.glb", format: "glb" },
  // { name: "response_outofstock_exchange01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_outofstock_exchange01_b.glb", format: "glb" },
  // 사용되지 않는 애니메이션 (outofstock_exchange 시나리오에서 01_a, 01_b만 사용)
  // { name: "response_outofstock_exchange02_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_outofstock_exchange02_a.glb", format: "glb" },
  // { name: "response_outofstock_exchange02_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_outofstock_exchange02_b.glb", format: "glb" },
  // { name: "response_productinfo01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_productinfo01_a.glb", format: "glb" },
  // { name: "response_productinfo01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_productinfo01_b.glb", format: "glb" },
  // { name: "response_shoppingbag01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_shoppingbag01_a.glb", format: "glb" },
  // { name: "response_shoppingbag01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_shoppingbag01_b.glb", format: "glb" },
  // { name: "response_shoppingbag01_c", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_shoppingbag01_c.glb", format: "glb" },
  { name: "response_speaking01", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_speaking01.glb", format: "glb" },
  { name: "response_speaking02", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_speaking02.glb", format: "glb" },
  { name: "response_speaking03", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_speaking03.glb", format: "glb" },
  // { name: "response_cancelmenu01_a", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_cancelmenu01_a.glb", format: "glb" },
  // { name: "response_cancelmenu01_b", type: "animation_only", path: "/glb/animations/nalnani/nn_nani@response_cancelmenu01_b.glb", format: "glb" },
];

/**
 * Nalnani 시나리오 설정 - 스마트 빌더 사용 ⭐️
 * 베이스 이름만 입력하면 자동으로 적절한 애니메이션과 패턴을 탐지합니다.
 */
const NALNANI_SCENARIOS: ScenarioConfigs<string> = {
  // "greeting_hi"만 입력하면 자동으로 greeting_hi01, greeting_hi02 등을 탐지
  entrance: SmartScenarioBuilders.auto("greeting_hi", nalnaniResources, {
    preferredMode: 'once',
    description: "입장 애니메이션",
    nextScenario: "toss"
  }),

  start: SmartScenarioBuilders.auto("greeting_start", nalnaniResources, {
    preferredMode: 'once',
    description: "시작 애니메이션"
  }),

  // "input_waiting"만 입력하면 자동으로 input_waiting01_a, input_waiting01_b 등을 찾아서 순차 페어로 구성
  waiting: SmartScenarioBuilders.auto("input_waiting", nalnaniResources, {
    preferredMode: 'last_loop',
    description: "대기 상태"
  }),

  listening: SmartScenarioBuilders.auto("input_listening", nalnaniResources, {
    preferredMode: 'last_loop',
    description: "사용자 입력을 듣는 상태"
  }),

  processing: SmartScenarioBuilders.auto("input_processing", nalnaniResources, {
    preferredMode: 'last_loop',
    description: "사용자 입력을 처리하는 상태"
  }),

  // "response_speaking"만 입력하면 자동으로 speaking01~03을 찾아서 랜덤 모드로 구성
  speaking: SmartScenarioBuilders.auto("response_speaking", nalnaniResources, {
    preferredMode: 'random',
    description: "말하기 상태"
  }),

  error: SmartScenarioBuilders.auto("response_error", nalnaniResources, {
    preferredMode: 'last_loop',
    description: "에러 상태 애니메이션"
  }),

  error_end: SmartScenarioBuilders.auto("response_error01_c", nalnaniResources, {
    preferredMode: 'once',
    description: "에러 상태 종료 애니메이션"
  }),

  toss: SmartScenarioBuilders.auto("payment_toss", nalnaniResources, {
    preferredMode: 'once',
    description: "결제 완료 애니메이션"
  }),
};

// 카메라 설정
const nalnaniCameraConfig: CameraConfig = {
  ...defaultConfig.camera,
  cameras: [
    {
      name: "nalnani_main_camera",
      type: "PerspectiveCamera",
      active: true,
      fov: 40,
      position: { x: 0, y: 10, z: 36.353 },
      rotation: {
        x: -1.78 * Math.PI / 180,
        y: 0 * Math.PI / 180,
        z: 0 * Math.PI / 180
      },
      near: 0.1,
      far: 200
    }
  ]
};

// 조명 설정
const nalnaniLightConfig: LightingConfig = {
  ...defaultConfig.lighting,
  lights: [
    {
      type: "DirectionalLight",
      color: 0xffffff,
      intensity: 1,
      position: { x: 5, y: 14.7, z: 16.4 },
      castShadow: true,
      shadow: {
        mapSize: { width: 1024, height: 1024 },
        radius: 6,
        autoUpdate: true
      }
    },
    {
      type: "HemisphereLight",
      skyColor: 0xfff9f0,
      groundColor: 0xab929d,
      intensity: 2,
      position: { x: 0, y: 10, z: 0 }
    },
    {
      type: "PointLight",
      color: 0xffffff,
      intensity: 0,
      position: { x: 1.964, y: 8.688, z: 9.242 },
      castShadow: false
    },
    {
      type: "AmbientLight",
      color: 0xffffff,
      intensity: 0.8
    }
  ],
  // 환경맵 설정
  environment: {
    loader: "HDR",
    path: "/hdr/panoramalow.hdr"
  }
};

// 렌더러 설정
const nalnaniRendererConfig: RendererConfig = {
  ...defaultConfig.renderer,
};

// 로더 설정
const nalnaniLoaderConfig: LoaderConfig = {
  ...defaultConfig.loader
};

/**
 * Nalnani 아바타 설정 - 완전 간소화! ⭐️
 * - scenarioConfigs만으로 모든 것을 처리합니다.
 * - 중복된 scenarioCounts 제거로 더 깔끔해졌습니다!
 */
export const nalnaniAvatarConfig: AvatarConfig = {
  type: 'nalnani' as const,
  modelKey: 'nalnani',
  resources: nalnaniResources,
  scenarioConfigs: NALNANI_SCENARIOS,
  scale: { x: 25, y: 25, z: 25 },
  lipsync: {
    indices: [22, 24, 31, 33, 34, 37, 40, 41, 43, 44, 45, 46, 47, 48],
    processingType: 'filter',
    config: {
      indices: [22, 24, 31, 33, 34, 37, 40, 41, 43, 44, 45, 46, 47, 48],
    }
  },
};

// Nalnani 통합 설정 인터페이스
export interface NalnaniConfig {
  loader: LoaderConfig;
  camera: CameraConfig;
  lighting: LightingConfig;
  renderer: RendererConfig;
  avatar: AvatarConfig;
}

/**
 * Nalnani 설정 통합 객체
 */
export const nalnaniConfig: NalnaniConfig = {
  loader: nalnaniLoaderConfig,
  camera: nalnaniCameraConfig,
  lighting: nalnaniLightConfig,
  renderer: nalnaniRendererConfig,
  avatar: nalnaniAvatarConfig
};

// ── 키오스크용 설정 (기존 값 보존) ──

const nalnaniKioskCameraConfig: CameraConfig = {
  ...defaultConfig.camera,
  cameras: [
    {
      name: "nalnani_main_camera",
      type: "PerspectiveCamera",
      active: true,
      fov: 38,
      position: { x: 0, y: 10, z: 36.353 },
      rotation: {
        x: -1.78 * Math.PI / 180,
        y: 0 * Math.PI / 180,
        z: 0 * Math.PI / 180
      },
      near: 0.1,
      far: 200
    }
  ]
};

const nalnaniKioskLightConfig: LightingConfig = {
  ...defaultConfig.lighting,
  lights: [
    {
      type: "DirectionalLight",
      color: 0xffffff,
      intensity: 1.3,
      position: { x: -0.953, y: 15.016, z: 12.993 },
      castShadow: true,
      shadow: {
        mapSize: { width: 1024, height: 1024 },
        radius: 6,
        autoUpdate: true
      }
    },
    {
      type: "DirectionalLight",
      color: 0xffecd6,
      intensity: 0.4,
      position: { x: 8.778, y: 1.735, z: 0.032 },
      castShadow: false,
      shadow: { radius: 1 }
    },
    {
      type: "HemisphereLight",
      skyColor: 0xfff2db,
      groundColor: 0xd7d0d0,
      intensity: 1.5,
      position: { x: 0, y: 10, z: 0 }
    },
    {
      type: "PointLight",
      color: 0xffffff,
      intensity: 10,
      position: { x: 1.964, y: 8.688, z: 9.242 },
      castShadow: false
    },
    {
      type: "AmbientLight",
      color: 0xffffff,
      intensity: 0.2
    }
  ],
  environment: {
    loader: "HDR",
    path: "/hdr/panoramalow.hdr"
  }
};

export const nalnaniKioskConfig: NalnaniConfig = {
  loader: nalnaniLoaderConfig,
  camera: nalnaniKioskCameraConfig,
  lighting: nalnaniKioskLightConfig,
  renderer: { ...defaultConfig.renderer, bloom: undefined },
  avatar: nalnaniAvatarConfig
};